import observer from 'saddlebag-observer';

import { TRACKING } from '../../../../constants';

export type EventName = string;

// we will sort out the track, trackChokePoint, trackSmartMetric functions in the future
export function track<Message>(
  eventName: EventName,
  fullSchemaName: string,
  message: Message,
): void {
  observer.publish('grappler-track', {
    eventName,
    fullSchemaName,
    message,
    isMiniEvent: true,
    consentRequired: true,
  });
}

export const trackChokePoint = (chokePointName: string) =>
  track(
    TRACKING.MESSAGES.EXPERIMENT_CHOKEPOINT,
    TRACKING.SCHEMAS.EXPERIMENT_CHOKEPOINT_SCHEMA,
    {
      name: chokePointName,
    },
  );
